<div class="with-floating-button">
    <div class="content">
        <page-header [title]="'admin.bibliotheque.devises.title' | translate" [listeItems]="listeTabItems"
                     (onSelectedItemChange)="onSelectedItemChange($event)">
        </page-header>

        <div [hidden]="selectedItem?.code !== Onglet.DEVISES">
            <list-view *ngIf="liste" [liste]="liste"></list-view>
        </div>
    </div>
    <floating-button [listeActions]="listeActions"></floating-button>
</div>